import {observer} from "mobx-react"
import {App} from "./App"
import {
    CmsOverviewPage,
    CmsDetailPage,
    CmsCreatePage, CmsTabType,
} from "../page/cms"


const CmsApp = observer(function CmsApp({mode ,tab}:
                        {mode: 'overview' | 'create' | 'detail' | 'ruleOverview'| 'ruleCreate' | 'ruleDetail' ,
                        tab?: CmsTabType}) {
    return <App>
        {mode === 'overview' && <CmsOverviewPage />}
        {mode === 'detail' && <CmsDetailPage tab={tab}/>}
        {mode === 'create' && <CmsCreatePage />}
    </App>
})

export {
    CmsApp
}
